// extracted by mini-css-extract-plugin
export var resizer = "_gc-0";